import { computeCoreNumbers } from './calculations';
import { weightedDigitTally } from './weighting';
import { detectThemes, buildDominantThemeRecords } from './themeDetection';
import { assembleReport } from './voiceLayer';
import { TIERS } from './tiers';
import { SAMPLE_PERSONAS } from './samplePersonas';

/**
 * End-to-end report build: calculations → weighted tally → theme detection → voice assembly.
 * @param {object} options - merged into input for sample flags / profile kind (non-destructive)
 */
function mergeInput(input, options) {
  const merged = { ...input };
  if (options && typeof options === 'object') {
    Object.keys(options).forEach((k) => {
      if (options[k] !== undefined) merged[k] = options[k];
    });
  }
  return merged;
}

export function buildNumerologyReport(input, options = {}) {
  const tier = TIERS.FULL;
  const mergedInput = mergeInput(input, options);
  const bundle = computeCoreNumbers(mergedInput);
  if (!bundle.ok) {
    return { ok: false, error: bundle.error };
  }

  const weighted = weightedDigitTally(bundle, bundle.nameGrid);
  const theme = detectThemes(bundle, weighted);
  const themeRecords = buildDominantThemeRecords(theme);
  // themeRecords are unused by assembleReport but kept for API compatibility (e.g. buildProfileReport.contributions).
  const report = assembleReport(bundle, theme, themeRecords);

  const samplePersonaId = mergedInput.samplePersonaId || null;
  const sampleDisplayName =
    mergedInput.sampleMode && samplePersonaId && SAMPLE_PERSONAS[samplePersonaId]
      ? SAMPLE_PERSONAS[samplePersonaId].displayName
      : null;

  const reportContext = {
    reportMode: mergedInput.sampleMode ? 'sample' : 'personal',
    samplePersonaId,
    sampleDisplayName,
    profileKind: bundle.meta.profileKind || 'numerology_only',
    pdfExportEligible: false,
  };

  return {
    ok: true,
    tier,
    bundle,
    weighted,
    theme,
    themeRecords,
    report,
    reportContext,
  };
}

export { TIERS, resolveTierFromBrowser } from './tiers';
